import { render, staticRenderFns } from "./SetTableColumns.vue?vue&type=template&id=3678cdee&scoped=true"
import script from "./SetTableColumns.vue?vue&type=script&lang=js"
export * from "./SetTableColumns.vue?vue&type=script&lang=js"
import style0 from "./SetTableColumns.vue?vue&type=style&index=0&id=3678cdee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3678cdee",
  null
  
)

export default component.exports